import React from 'react';
import { Sparkles } from 'lucide-react';

const SIZES = {
  sm: 'w-8 h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14',
};

const ICON_SIZES = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-7 h-7',
};

export default function OlliAvatar({ size = 'md', avatarSrc, className = '' }) {
  const sizeClass = SIZES[size] || SIZES.md;
  const iconSize = ICON_SIZES[size] || ICON_SIZES.md;

  if (avatarSrc) {
    return (
      <img
        src={avatarSrc}
        alt="Olli"
        className={`${sizeClass} rounded-full object-cover ${className}`}
      />
    );
  }

  return (
    <div
      className={`${sizeClass} rounded-full flex items-center justify-center shrink-0 ${className}`}
      style={{ background: 'linear-gradient(135deg, #3B82F6, #8B5CF6)' }}
    >
      <Sparkles className={`${iconSize} text-white`} />
    </div>
  );
}
